import {RoomMedia} from "@/core/api/room.media.api";
import {RoomFile} from "@/core/api/room.file.api";
import _ from "lodash";

export default {
    changeRoomMediaFile: async ({ dispatch, commit, getters, rootGetters }, {mediaId, roomGroupId}) => {
        await RoomMedia.changeRoomMediaFile({roomGroupId, mediaId});
    },
    uploadRoomMediaFile: async ({ dispatch, commit, getters, rootGetters }, {roomGroupId='default', filename, file}) => {
        let fileExt = file.name.substring( file.name.lastIndexOf('.')+1 ).toLowerCase();
        if(!getters['allowedFileExts'].includes(fileExt)) {
            throw new Error('not supported extension, '+ file.name)
        }
        const id = Date.now();
        let uploadObj = {
            id, roomGroupId, filename,
            total: file.size,
            loaded: 0,
            percent: 0,
            startTime: Date.now()
        };

        // TODO: duration set
        function checkMedia(file) {
            return new Promise((resolve, reject) => {
                let video = document.createElement(getters['isAudio'](fileExt) ? 'audio' : 'video');
                video.preload = 'metadata';
                video.onloadedmetadata = () => {
                    if(!isFinite(video.duration)) {
                        reject({error: 'load_duration_fail'});
                        return;
                    }
                    file.duration = Math.round(video.duration);
                    if(getters['isVideo'](fileExt) && video.videoWidth < 1 && video.videoHeight < 1 ) {
                        reject({error: 'video_codec_not_supported'});
                        return;
                    }
                    resolve(video);
                }
                video.onerror = (e) => {
                    console.error('media error', e);
                    reject('load_file_fail');
                }
                video.src = URL.createObjectURL(file);
            })
        }

        return checkMedia(file)
            .then(async (video) => {
                console.log('check Media success', video);
                commit('UPLOAD_ROOM_MEDIA', uploadObj);

                let res;
                try {
                    res = await RoomMedia.generateUploadPresignedUrl()
                    if(!res.url) {
                        throw new Error();
                    }
                } catch (e) {
                    commit('REMOVE_ROOM_MEDIA_FILE', uploadObj)
                    console.error('Could not get presigned URL ', e);
                    return;
                }
                const {url, storageType} = res;
                _.merge(uploadObj, {
                    url,
                    storageType,
                    duration: file.duration,
                    filesize: file.size,
                    contentType: file.type
                });
                try {
                    const cancel = new AbortController()
                    let removed = false
                    let result = await RoomFile.uploadToPresignedUrl({
                        url, file, onUploadProgress: e=> {
                            if(removed) {
                                return;
                            }
                            let uploadRoomMediaFile = getters['getUploadRoomMediaFile'](id)
                            if(!uploadRoomMediaFile) {
                                uploadObj.abort = true;
                                cancel.abort()
                            }
                            commit('CHANGE_UPLOAD_ROOM_MEDIA', {
                                id,
                                loaded: e.loaded,
                                removed
                            });
                        },
                        signal: cancel.signal
                    });
                    if(!uploadObj.abort) {
                        await RoomMedia.completePresignedUrl(uploadObj)
                    }
                    commit('REMOVE_UPLOAD_ROOM_MEDIA_FILE', uploadObj)
                }catch (e) {
                    console.error('Could not upload to Presigned-Url', e);
                    commit('REMOVE_UPLOAD_ROOM_MEDIA_FILE', uploadObj);
                    this.$alert({
                        text: this.$t('media.error.uploadFail'),
                        onlyOk: true
                    });
                } finally {
                    commit('REMOVE_ROOM_MEDIA_FILE', uploadObj)
                }
            })
            .catch(error => {
                throw new Error(error)
            })

    },
    removeRoomMediaFile: async ({ dispatch, commit, getters, rootGetters}, {roomGroupId, mediaId}) => {
      await RoomMedia.removeRoomMediaFile({roomGroupId, mediaId})
    },
    removeUploadRoomMediaFile: async ({ dispatch, commit, getters, rootGetters}, roomMediaFile) => {
        commit('REMOVE_UPLOAD_ROOM_MEDIA_FILE', roomMediaFile)
    },
    changeRoomMedia: async ({ dispatch, commit, getters, rootGetters}, {roomGroupId, mediaId}) => {
        let res = await RoomMedia.changeRoomMedia({roomGroupId, mediaId})
        // 미디어 변경 후 play
        let roomMedia = res.data
        roomMedia.seekTime = 0;
        await RoomMedia.playRoomMedia(roomMedia)
    },
    playRoomMedia: async ({ dispatch, commit, getters, rootGetters}, {roomGroupId, mediaId, seekTime}) => {
        await RoomMedia.playRoomMedia({roomGroupId, mediaId, seekTime})
    },
    pauseRoomMedia: async ({ dispatch, commit, getters, rootGetters}, {roomGroupId, seekTime, autoPause}) => {
        await RoomMedia.pauseRoomMedia({roomGroupId, seekTime, autoPause})
    },
    changeRoomMediaPlayType: async ({ dispatch, commit, getters, rootGetters}, {roomGroupId, playType}) => {
        await RoomMedia.changeRoomMediaPlayType({roomGroupId, playType})
    },
}
